import loadable from '@loadable/component'

export const MoreLink = loadable(() => import('./MoreLink'))
export type { MoreLinkProps } from './MoreLink'
